import { getMessage } from '@tcc/i18n';
import { createUnit } from '../../i18n/unitQtyWrapper';

const isNil = (value) => [null, undefined].includes(value);

/**
 * Returns new QtyFactory instance using a unitKey or a N/A
 * @param {Number|String|null} scalar
 * @param {String|null;;} unitKey
 * @param {Number} [precision]
 * @return {QtyFactory}
 */

export const createUnitOrNotApplicable = (scalar, unitKey, precision) => {
  if (isNil(scalar) || isNil(unitKey)) {
    const NA = getMessage('forecast.current.notApplicable');
    return {
      scalar: NA,
      forLocaleGroup: () => NA,
      scalarLocaleString: NA,
      unitKey: NA,
    };
  }

  return createUnit(scalar, unitKey, precision);
};
